import React from 'react';
import { Box, Typography } from '@mui/material';

/**
 * メール本文のプレビュー (サーバーで CSS インライン化・差し込み済みの HTML を sandbox iframe で表示)。
 * スクリプトは実行させない。リンクは新しいタブで開く。
 */
type Props = {
  html: string | null;
  height?: number | string;
  emptyMessage?: string;
};

const MailPreviewFrame: React.FC<Props> = ({ html, height = 520, emptyMessage = 'プレビューはまだありません' }) => {
  if (!html) {
    return (
      <Box sx={{ height, display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#f8fafc', border: '1px dashed #cbd5e1', borderRadius: 1 }}>
        <Typography sx={{ fontSize: 13, color: 'text.secondary' }}>{emptyMessage}</Typography>
      </Box>
    );
  }
  // 本文内のリンクは別タブで開く (iframe 内遷移を防ぐ)
  const doc = html.includes('<base ') ? html : html.replace(/<head([^>]*)>/i, '<head$1><base target="_blank">');
  return (
    <Box sx={{ height, border: '1px solid #e2e8f0', borderRadius: 1, overflow: 'hidden', bgcolor: '#fff' }}>
      <iframe title="mail-preview" srcDoc={doc} sandbox="allow-popups allow-popups-to-escape-sandbox" style={{ width: '100%', height: '100%', border: 0 }} />
    </Box>
  );
};

export default MailPreviewFrame;
